import React from 'react';

import { P2pTransferWizard } from '@swf/first';

import FirstRoute from './FirstRoute';

const P2pTransferRoute: React.FC = () => <FirstRoute component={P2pTransferWizard} noCache />;

export default P2pTransferRoute;
